import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M19.25 10V18C19.25 18.6904 18.6904 19.25 18 19.25H6C5.30964 19.25 4.75 18.6904 4.75 18V9.75M14 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V9.75M19.25 8V1.5M16 4.75H22.5M16.5 9.75H9.25M4.75 9.75H9.25M9.25 9.75V19.25" />
	</SVG>
);
